import { ChatIcon, CompassIcon, FlameIcon, UserIcon, type IconProps } from "./icons";

export interface NavItem {
  href: string;
  /** Key into the `nav` message namespace (resolved by the rendering component). */
  labelKey: string;
  Icon: (props: IconProps) => React.JSX.Element;
}

/** Single source of truth for primary navigation (tab bar + desktop rail). */
export const NAV_ITEMS: NavItem[] = [
  { href: "/deck", labelKey: "deck", Icon: FlameIcon },
  { href: "/browse", labelKey: "browse", Icon: CompassIcon },
  { href: "/matches", labelKey: "matches", Icon: ChatIcon },
  { href: "/me", labelKey: "profile", Icon: UserIcon },
];

function matchesPath(pathname: string, href: string) {
  return pathname === href || pathname.startsWith(href + "/");
}

/**
 * Whether a nav href is active for the current pathname. The Profile tab
 * (`/me`) redirects to the viewer's own `/u/[username]`, so it is also active
 * there — pass `ownProfilePath` to enable that match.
 */
export function isActive(pathname: string, href: string, ownProfilePath?: string | null) {
  if (matchesPath(pathname, href)) return true;
  return href === "/me" && !!ownProfilePath && matchesPath(pathname, ownProfilePath);
}

/** The signed-in user's own profile path, for the Profile-tab active match. */
export function ownProfilePathOf(username: string | undefined): string | null {
  return username ? `/u/${username}` : null;
}
